export const CHECKOUT_URL = 'https://mega-pack-carpinteria.impultienda.ar/checkout'

/* Todos los botones e imágenes llevan a la sección de compra */
export const OFFER_ANCHOR = '#oferta'

export const SUPPORT_EMAIL = 'soportescmdigital@gmail.com'

export const PACK_IMAGE =
  'https://cdn.magicpatterns.com/uploads/vZqNkS2NDQjeEDD1dYsQnE/Carpinteria_en_melamina_desde_cero.png'

export const PRODUCT_NAME = 'MEGA PACK CARPINTERÍA EN MELAMINA DESDE CERO'

export const PRICE = '$19.990'
export const BONUS_VALUE = '$39.950'

/* 1. PROBLEMA */
export const problems = [
  {
    icon: 'layers' as const,
    title: 'INFORMACIÓN DISPERSA',
    desc: 'Guardás videos sobre cortes, medidas, armado de muebles, placares y cocinas, pero cada uno explica algo diferente y no sabés cómo conectar todo.',
  },
  {
    icon: 'help' as const,
    title: 'NO SABÉS QUÉ APRENDER PRIMERO',
    desc: 'Melamina, herramientas, planos, despieces, tapacantos, bisagras, correderas, cajones... hay tantas técnicas y materiales que empezar parece complicado.',
  },
  {
    icon: 'route' as const,
    title: 'TE FALTA UNA RUTA',
    desc: 'Querés aprender a fabricar tus propios muebles y desarrollar una habilidad que puedas convertir en un servicio, pero necesitás un camino desde las primeras medidas hasta el armado y la instalación.',
  },
  {
    icon: 'clock' as const,
    title: 'SEGUÍS POSTERGANDO',
    desc: 'Querés comenzar, pero pasan las semanas y continuás mirando tutoriales en lugar de fabricar tu primer mueble con un método organizado.',
  },
]

/* 2. SOLUCIÓN — 6 TOMOS */
export const tomos = [
  {
    icon: 'hammer' as const,
    title: 'CARPINTERÍA EN MELAMINA DESDE CERO',
    desc: 'Conocé los materiales, herramientas, espesores, tipos de tableros, sistemas de unión, normas de seguridad y técnicas básicas para comenzar a fabricar tus primeros muebles.',
  },
  {
    icon: 'ruler' as const,
    title: 'MEDICIONES, PLANOS Y DISEÑO DE MUEBLES',
    desc: 'Aprendé a tomar medidas, interpretar planos, calcular dimensiones, organizar despieces y diseñar escritorios, bibliotecas, estantes y muebles personalizados.',
  },
  {
    icon: 'drill' as const,
    title: 'CORTES, CANTEADO Y PERFORACIONES PROFESIONALES',
    desc: 'Comprendé cómo preparar cortes, identificar piezas, colocar tapacantos, realizar perforaciones y conseguir mejores terminaciones evitando errores frecuentes.',
  },
  {
    icon: 'box' as const,
    title: 'ARMADO DE MUEBLES PASO A PASO',
    desc: 'Aprendé a ensamblar estructuras, unir tableros, colocar estantes, instalar puertas y cajones, regular herrajes y fabricar muebles funcionales.',
  },
  {
    icon: 'house' as const,
    title: 'PLACARES, COCINAS Y MUEBLES A MEDIDA',
    desc: 'Conocé cómo diseñar y fabricar placares, bajo mesadas, alacenas, escritorios y muebles adaptados a distintos espacios y necesidades.',
  },
  {
    icon: 'calculator' as const,
    title: 'INSTALACIÓN, PRESUPUESTOS Y TRABAJOS POR ENCARGO',
    desc: 'Aprendé a organizar instalaciones, calcular materiales, preparar presupuestos, controlar costos y comenzar a estructurar tus primeros trabajos para clientes.',
  },
]

/* 3. BONOS */
export const bonuses = [
  {
    icon: 'compass' as const,
    title: '50 PLANOS DE MUEBLES EN MELAMINA CON MEDIDAS™',
    desc: 'Una colección de 50 proyectos de muebles con medidas de referencia, piezas y orientaciones de armado para practicar y desarrollar tus propios diseños.',
    value: 'Valor: $7.990',
  },
  {
    icon: 'calculator' as const,
    title: 'CALCULADORA DE MATERIALES, COSTOS Y PRESUPUESTOS™',
    desc: 'Métodos, fórmulas y ejemplos para calcular melamina, tapacantos, herrajes, mano de obra, precios y rentabilidad de cada proyecto.',
    value: 'Valor: $5.990',
  },
  {
    icon: 'wrench' as const,
    title: 'GUÍA COMPLETA DE HERRAJES, BISAGRAS Y CORREDERAS™',
    desc: 'Aprendé a seleccionar, instalar y regular bisagras, correderas, tornillos, tiradores y accesorios para fabricar muebles funcionales.',
    value: 'Valor: $6.990',
  },
  {
    icon: 'checks' as const,
    title: '30 PROYECTOS PRÁCTICOS DE CARPINTERÍA EN MELAMINA™',
    desc: '30 proyectos organizados por dificultad para practicar mediciones, cortes, armado, instalación de herrajes y terminaciones.',
    value: 'Valor: $8.990',
  },
  {
    icon: 'clipboard' as const,
    title: 'PLANTILLAS DE CORTE, DESPIECE Y PEDIDOS LISTAS PARA USAR™',
    desc: 'Plantillas para registrar medidas, preparar pedidos a madereras, calcular materiales, organizar presupuestos y controlar trabajos.',
    value: 'Valor: $9.990',
  },
]

/* 4. BENEFICIOS */
export const benefits = [
  {
    icon: 'route' as const,
    title: 'MENOS CONFUSIÓN',
    desc: 'Dejá de saltar entre tutoriales y seguí una ruta desde las primeras mediciones hasta el diseño, armado e instalación de muebles.',
  },
  {
    icon: 'book' as const,
    title: 'MÁS CONOCIMIENTO PRÁCTICO',
    desc: 'Comprendé melamina, herramientas, planos, cortes, tapacantos, bisagras, correderas, placares y muebles de cocina con explicaciones organizadas.',
  },
  {
    icon: 'eye' as const,
    title: 'COMPRENDÉ LO QUE ESTÁS HACIENDO',
    desc: 'Empezá a mirar un mueble y reconocer cómo está construido, qué piezas necesita, cómo calcular sus medidas y qué pasos seguir para fabricarlo.',
  },
  {
    icon: 'award' as const,
    title: 'UNA NUEVA HABILIDAD',
    desc: 'Desarrollá conocimientos para fabricar muebles propios, ahorrar en determinados proyectos y dar tus primeros pasos para ofrecer trabajos por encargo.',
  },
]

/* 5. TESTIMONIOS */
export const testimonials = [
  {
    quote:
      'Siempre quise hacer mis propios muebles pero no entendía cómo se pasaba de una idea a las piezas que hay que pedir en la maderera. Con los tomos de mediciones y planos aprendí a armar un despiece y la primera vez que llevé mi lista de cortes la entendieron sin problemas.',
    author: 'Martín Gómez',
    role: 'Empleado administrativo, 34 años',
    location: 'Córdoba, Argentina',
  },
  {
    quote:
      'Arranqué sin saber diferenciar un tablero de otro. Lo que más me sirvió fue el armado paso a paso: entendí cómo identificar cada pieza, en qué orden unirlas y cómo escuadrar la estructura. Mi primera biblioteca para el living quedó firme y derecha.',
    author: 'Laura Benítez',
    role: 'Ama de casa, 41 años',
    location: 'Rosario, Argentina',
  },
  {
    quote:
      'Necesitaba un escritorio a medida para trabajar desde casa y los que veía no entraban en el espacio. Con las guías de diseño calculé las medidas, ajusté la profundidad y lo fabriqué yo mismo. Ahora estoy planeando el mueble para la tele.',
    author: 'Diego Fernández',
    role: 'Diseñador gráfico, 29 años',
    location: 'La Plata, Argentina',
  },
  {
    quote:
      'Las bisagras y las correderas eran lo que más me frenaba. La guía de herrajes y los proyectos prácticos ordenados por dificultad me ayudaron a avanzar de a poco. Empecé con un estante simple y ya terminé una cajonera para el taller.',
    author: 'Roberto Sánchez',
    role: 'Jubilado, 52 años',
    location: 'Mendoza, Argentina',
  },
  {
    quote:
      'Una vecina me pidió un placard después de ver los muebles que hice en casa. Usé las plantillas de despiece y el método de presupuestos para calcular materiales, mano de obra y tiempos. Fue mi primer trabajo por encargo y lo pude organizar sin improvisar.',
    author: 'Carolina Ruiz',
    role: 'Emprendedora, 38 años',
    location: 'Mar del Plata, Argentina',
  },
]

/* 6. FAQ */
export const faqs = [
  { q: '¿Es físico o digital?', a: 'Es un producto 100% digital.' },
  {
    q: '¿Necesito conocimientos previos?',
    a: 'No. El contenido comienza con los fundamentos de la carpintería en melamina y avanza progresivamente.',
  },
  {
    q: '¿Qué voy a aprender?',
    a: 'Mediciones, planos, cortes, canteado, perforaciones, armado, herrajes, placares, cocinas, instalación y presupuestos.',
  },
  {
    q: '¿Incluye ejercicios?',
    a: 'Sí. Incluye ejemplos, proyectos prácticos y actividades para aplicar lo aprendido.',
  },
  {
    q: '¿Los bonos tienen costo adicional?',
    a: 'No. Los 5 bonos están incluidos en el precio del Mega Pack.',
  },
  {
    q: '¿Es un pago único?',
    a: 'Sí. Pagás una sola vez, sin mensualidades.',
  },
  {
    q: '¿Obtengo acceso inmediatamente?',
    a: 'Sí. El acceso al material digital se entrega después de confirmar el pago.',
  },
  {
    q: '¿Esto me habilita profesionalmente?',
    a: 'Es material educativo. No reemplaza la práctica, la formación profesional ni las habilitaciones que puedan corresponder.',
  },
  {
    q: '¿Puedo aprender a mi ritmo?',
    a: 'Sí. Podés estudiar los tomos y realizar los proyectos según tu disponibilidad.',
  },
  {
    q: '¿Dónde solicito soporte?',
    a: 'Podés escribir a soportescmdigital@gmail.com.',
  },
]

/* POP-UP DE COMPRAS RECIENTES — ARGENTINA */
export const recentBuyers = [
  { name: 'Javier Romero', city: 'Córdoba', minutes: 2 },
  { name: 'Lucía Fernández', city: 'Rosario', minutes: 5 },
  { name: 'Gustavo Herrera', city: 'Buenos Aires', minutes: 8 },
  { name: 'Andrés Medina', city: 'Mendoza', minutes: 12 },
  { name: 'Romina Castro', city: 'La Plata', minutes: 16 },
  { name: 'Pablo Giménez', city: 'Mar del Plata', minutes: 20 },
  { name: 'Sergio Aguirre', city: 'Salta', minutes: 25 },
  { name: 'Florencia Vera', city: 'San Miguel de Tucumán', minutes: 30 },
  { name: 'Matías Ledesma', city: 'Neuquén', minutes: 34 },
  { name: 'Hernán Quiroga', city: 'Santa Fe', minutes: 41 },
]
